var ɵ0 = function (created) { return created.startOf('day'); }, ɵ1 = function (created) { return undefined; }, ɵ2 = function (created) { return created.startOf('week'); }, ɵ3 = function (created) { return created.plus({ weeks: 1 }).startOf('week'); }, ɵ4 = function (created) { return created.startOf('month'); }, ɵ5 = function (created) { return undefined; }, ɵ6 = function (created) {
    if (created.month % 2 === 0) {
        return created.minus({ months: 1 }).startOf('month');
    }
    return created.startOf('month');
}, ɵ7 = function (created) {
    if (created.month % 2 === 0) {
        return created.plus({ months: 1 }).startOf('month');
    }
    return created.plus({ months: 2 }).startOf('month');
}, ɵ8 = function (created) {
    if (created.month % 3 === 0) {
        return created.minus({ months: 2 }).startOf('month');
    }
    else if (created.month % 3 === 1) {
        return created.startOf('month');
    }
    return created.minus({ months: 1 }).startOf('month');
}, ɵ9 = function (created) {
    if (created.month % 3 === 0) {
        return created.plus({ months: 1 }).startOf('month');
    }
    else if (created.month % 3 === 1) {
        return created.plus({ months: 3 }).startOf('month');
    }
    return created.plus({ months: 2 }).startOf('month');
}, ɵ10 = function (created) { return created.startOf('year'); }, ɵ11 = function () { return undefined; };
export var BudgetRanges = {
    daily: {
        scale: 'day',
        since: ɵ0,
        until: ɵ1,
    },
    weekly: {
        scale: 'month',
        since: ɵ2,
        until: ɵ3,
    },
    monthly: {
        scale: 'month',
        since: ɵ4,
        until: ɵ5,
    },
    bimonthly: {
        scale: 'month',
        since: ɵ6,
        until: ɵ7,
    },
    quarterly: {
        scale: 'month',
        since: ɵ8,
        until: ɵ9,
    },
    yearly: {
        scale: 'year',
        since: ɵ10,
        until: ɵ11,
    },
};
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6, ɵ7, ɵ8, ɵ9, ɵ10, ɵ11 };
